import type { SxProps, Theme } from '@mui/material/styles';

/**
 * React-admin maps `readOnly` to MUI `disabled`, which greys out fields.
 * Apply this `sx` on a wrapper (e.g. Stack/Box) to restore normal colors while staying non-editable.
 */
export const showModeReadOnlySx: SxProps<Theme> = {
    '& .MuiInputBase-root.Mui-disabled': {
        opacity: 1,
        color: 'text.primary',
    },
    '& .MuiInputBase-input.Mui-disabled': {
        WebkitTextFillColor: theme => theme.palette.text.primary,
        color: 'text.primary',
    },
    '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
        borderColor: theme =>
            theme.palette.mode === 'light'
                ? 'rgba(0, 0, 0, 0.23)'
                : 'rgba(255, 255, 255, 0.23)',
    },
    '& .MuiInputLabel-root.Mui-disabled': {
        color: 'text.secondary',
    },
    '& .MuiFormHelperText-root.Mui-disabled': {
        color: 'text.secondary',
    },
    '& .MuiSelect-select.Mui-disabled': {
        WebkitTextFillColor: theme => theme.palette.text.primary,
    },
    '& .MuiSwitch-switchBase.Mui-disabled': {
        opacity: 1,
        color: theme => theme.palette.grey[300],
        '&.Mui-checked': {
            color: theme => theme.palette.primary.main,
        },
        '& + .MuiSwitch-track': {
            opacity: 1,
            backgroundColor: theme => theme.palette.grey[400],
        },
        '&.Mui-checked + .MuiSwitch-track': {
            backgroundColor: theme => theme.palette.primary.main,
            opacity: 0.38,
        },
    },
};
